import { IPayloadAction } from "../../../../react-core/Flux/PayloadStore";

import { SessionInfo } from "../../../../Wrap/Models/Models/Session/SessionInfo";

import { SessionInfoClient } from "../../../../Wrap/Api/Session/SessionInfo";

import { SessionInfoDispatcher } from "./Variables";

import { ActionType } from "../../../../react-core/Flux/ActionType";

export type ISessionInfoActions = IPayloadAction<SessionInfo>;

export class SessionInfoActions {
    public static get(callback?: (val: SessionInfo) => void): void {
        const client = new SessionInfoClient();
        const promise = client.get();
        SessionInfoDispatcher.dispatch({ actionType: ActionType.Loading });

        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
            SessionInfoDispatcher.dispatch({ actionType: ActionType.Success, payload: result });
        });
    }
}
